import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BillCard from "../BillCard/BillCard";
import "./BillList.css";
import Button from "@mui/joy/Button";
import { Grid, Input, Option, Select, Stack, Typography } from "@mui/joy";
import SearchIcon from "@mui/icons-material/Search";
import { statesList } from "../../StateCodes";

const BillList = ({
  bills,
  loading,
  hasMore,
  setSearchParams,
  searchParams,
  handleSearch,
}) => {
  const [loadingBills, setLoadingBills] = useState(loading);
  const [hasMoreBills, setHasMoreBills] = useState(hasMore);

  useEffect(() => {
    setLoadingBills(loading);
    setHasMoreBills(hasMore);
  }, [loading, hasMore]);

  return (
    <Stack
      direction={"column"}
      padding={4}
      spacing={3}
      sx={{ backgroundColor: "#F2F2F2", alignItems: "center" }}
    >
      <Stack
        className="bill-list-filter-container"
        direction={"row"}
        spacing={3}
        component={'form'}
        onSubmit={handleSearch}
      >
          <Input
            placeholder="Search by keywords"
            startDecorator={<SearchIcon />}
            value={searchParams.keyword}
            onChange={(e) => 
              setSearchParams({ ...searchParams, keyword: e?.target.value })
            }
            sx={{ width: "100%" }}
          />
          {/* <Select
            placeholder="Search by state"
            defaultValue={searchParams.state}
            sx={{ width: "50%" }}
            onChange={(e) =>
              setSearchParams({ ...searchParams, state: e?.target.value })
            }
          >
            {Object.keys(statesList).map((key, index) => (
              <Option value={key} key={index}>
                {statesList[key]}
              </Option>
            ))}
          </Select> */}
          <Button type="submit">Search</Button>
      </Stack>

      <Grid
        container
        spacing={{ xs: 2, sm: 3 }}
        columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
        sx={{ maxWidth: "1280px" }}
      >
        {bills?.map((bill, index) => {
          return (
            <Grid key={index} xs={1} sx={{ display: "flex" }}>
              <BillCard bill={bill} />
            </Grid>
          );
        })}
      </Grid>

      {loadingBills && <Button color="primary" variant="soft" loading></Button>}
      {!hasMoreBills && (
        <Typography level="body-sm">No more bills to load</Typography>
      )}
    </Stack>
  );
};

// Prop types for our Component
BillList.propTypes = {
  bills: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  searchParams: PropTypes.object.isRequired,
  setSearchParams: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
};

// Default Props for our Component
BillList.defaultProps = {
  loading: false,
  hasMore: true,
};

export default BillList;
